import React, { useMemo, useEffect, useState } from "react";
import { useData } from "../context/DataContext";
import styles from "../Assets/css/fleet.module.css";
import capicityForcast from "../Assets/images/capacity-forecast.png";
import Map from "./Map";
import mainlogo from "../Assets/images/logo.png";
import logoSvg from "../Assets/images/logo.svg";

import { Link, useNavigate } from "react-router-dom";
import Loader from "../component/Loader";
import Chartapp from "../component/chart";
import Select from "react-select";
import { US_STATES } from "../context/DataContext";

const Homepage = () => {
  const {
    data: contextData,
    franklinData: contextFranklinData,
    unifiedDevices: contextUnifiedDevices,
    utilities: contextUtilities, // Rename to avoid conflict or just use directly
    loading: contextLoading,
    fetchAllData
  } = useData();

  const [accessToken, setAccessToken] = useState(null);

  // Local state for display (filtered by user)
  const [displayData, setDisplayData] = useState(contextData || []);

  // We can keep these if we want, or derive them.
  // derived from contextData
  // const [deviceCounts, setDeviceCounts] = useState({}); 
  // const [dispatchingDeviceCounts, setdispatchingDeviceCounts] = useState({});

  const [selectedDevice, setSelectedDevice] = useState(null);
  const [thermostatData, setThermostatData] = useState([]);
  const [inverterData, setinverterData] = useState([]);
  const [vehicleData, setVehicleData] = useState([]);

  // const [unifiedDevices, setUnifiedDevices] = useState([]); // Use contextUnifiedDevices
  // const [utilities, setUtilities] = useState([]); // Use contextUtilities

  const Navigate = useNavigate();

  const [locations, setLocations] = useState([]);
  const [selectedState, setSelectedState] = useState("All");
  const [selectedUtility, setSelectedUtility] = useState("All");

  // APIs are now in context, but individual device fetches (thermostat list etc) might still be here?
  // handleFilterChange uses specific URLs.


  const loading = contextLoading; // Use context loading
  let capacity = 0;
  let currentlyDispatching = 0;
  let generatingCapacity = 0;
  // const [dispatchingDeviceCounts, setdispatchingDeviceCounts] = useState({});

  useEffect(() => {
    const storedAccessToken = localStorage.getItem("accessToken");
    if (storedAccessToken) {
      setAccessToken(storedAccessToken);
      fetchAllData(storedAccessToken);
    }
  }, []);

  useEffect(() => {
    if (contextData) {
      setDisplayData(contextData);
    }
  }, [contextData]);



  // useEffect(() => {
  //     if (Object.keys(deviceCounts).length > 0) {
  //         handleFilterChange("1"); // Select 'All' by default when deviceCounts updates
  //     }
  // }, [deviceCounts]);
  // const fetchData = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await fetch(connectListApi, {
  //       method: "GET",
  //       headers: {
  //         Authorization: `Bearer ${accessToken}`,
  //         "Content-Type": "application/json",
  //       },
  //     });
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch data");
  //     }
  //     const data = await response.json();
  //     console.log("Device data:", data);
  //     const deviceCounts = {};
  //     data.forEach((device) => {
  //       if (!device.device_type || typeof device.device_type !== "string") {
  //         return; // Skip if device_type is missing or not a string
  //       }

  //       const deviceType = device.device_type
  //         .toLowerCase()
  //         .replace(/\s+/g, "")
  //         .replace(/^(.)/, (match, p1) => p1.toUpperCase());
  //       deviceCounts[deviceType] = (deviceCounts[deviceType] || 0) + 1;
  //       if (
  //         device.vpp_participations &&
  //         device.vpp_participations.length > 0 &&
  //         device.vpp_participations[0].is_dispatching === true
  //       ) {
  //         dispatchingDeviceCounts[deviceType] =
  //           (dispatchingDeviceCounts[deviceType] || 0) + 1;
  //       }
  //     });
  //     console.log(dispatchingDeviceCounts, "devices");
  //     setdispatchingDeviceCounts(dispatchingDeviceCounts);
  //     setDeviceCounts(deviceCounts);
  //     setData(data);
  //     setLoading(false);
  //     console.log(data, "data");
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error:", error);
  //   }
  // };

  // const fetchTextureDevices = async () => {
  //   try {
  //     const response = await fetch(connectListApi, {
  //       headers: { Authorization: `Bearer ${accessToken}` },
  //     });
  //     if (!response.ok) throw new Error("Failed to fetch texture devices");
  //     const result = await response.json();

  //     const allowed = ["inverter", "thermostat", "vehicle", "battery"];
  //     const counts = {};

  //     result
  //       .filter(
  //         (d) =>
  //           d.device_type &&
  //           allowed.includes(d.device_type.toLowerCase().replace(/\s+/g, ""))
  //       )
  //       .forEach((d) => {
  //         const type = d.device_type.toLowerCase().replace(/\s+/g, "");
  //         const key = type.charAt(0).toUpperCase() + type.slice(1);
  //         counts[key] = (counts[key] || 0) + 1;
  //       });

  //     setDeviceCounts(counts);
  //     setData(result);
  //   } catch (err) {
  //     console.error("Texture devices error:", err);
  //   }
  // };

  // unifiedDevices and utilities are now from context
  // Derived calculations
  const { deviceCounts, dispatchingDeviceCounts } = useMemo(() => {
    if (!contextData) return { deviceCounts: {}, dispatchingDeviceCounts: {} };

    const counts = {};
    const dispatchingCounts = {};

    contextData.forEach((device) => {
      // Data in context is already filtered by allowedTypes, but we need to normalize types for keys
      const normalized = device.device_type.toLowerCase().replace(/\s+/g, "");
      const formattedType = normalized.charAt(0).toUpperCase() + normalized.slice(1);

      counts[formattedType] = (counts[formattedType] || 0) + 1;

      if (
        device.vpp_participations &&
        device.vpp_participations.length > 0 &&
        device.vpp_participations[0].is_dispatching === true
      ) {
        dispatchingCounts[formattedType] = (dispatchingCounts[formattedType] || 0) + 1;
      }
    });
    return { deviceCounts: counts, dispatchingDeviceCounts: dispatchingCounts };

  }, [contextData]);

  const unifiedDevicesList = contextUnifiedDevices || [];

  const solarkCount = unifiedDevicesList.filter((d) => d.type === "Sol-Ark").length;
  const hoymilesCount = unifiedDevicesList.filter(
    (d) => d.type === "Hoymiles"
  ).length;
  const franklinUnifiedCount = unifiedDevicesList.filter(
    (d) => d.type === "Franklin"
  ).length;
  const combinedDeviceCounts = useMemo(() => {
    return {
      Inverter: deviceCounts.Inverter || 0, // Old inverters (if any)
      Thermostat: deviceCounts.Thermostat || 0,
      Vehicle: deviceCounts.Vehicle || 0,
      Battery: deviceCounts.Battery || 0,
      SolArk: solarkCount, // New
      Hoymiles: hoymilesCount, // New
      Franklin: franklinUnifiedCount, // New Franklin from unified
    };
  }, [deviceCounts, hoymilesCount, solarkCount, franklinUnifiedCount]);

  // const combinedDeviceCounts = useMemo(() => {
  //   return {
  //     ...deviceCounts,
  //     franklinwh: franklinCount !== null ? franklinCount : 0,
  //   };
  // }, [deviceCounts, franklinCount]);
  // console.log("Combined Device Counts:", combinedDeviceCounts);
  // const handleDetailsClick = (deviceType) => {
  //   console.log("Clicked on device type:", deviceType);

  //   const selectedDeviceData = data.find(
  //     (device) =>
  //       device.device_type
  //         .toLowerCase()
  //         .replace(/\s+/g, "")
  //         .replace(/^(.)/, (match, p1) => p1.toUpperCase()) === deviceType
  //   );
  //   if (selectedDeviceData) {
  //     console.log("Selected Device Data:", selectedDeviceData);
  //     setSelectedDevice(selectedDeviceData);

  //     if (deviceType.toLowerCase() === "inverter") {
  //       Navigate(`/InverterDetails`);
  //     } else if (deviceType.toLowerCase() === "thermostat") {
  //       Navigate(`/ThermostatDetails`);
  //     } else if (deviceType.toLowerCase() === "vehicle") {
  //       Navigate(`/VehicleDetails`);
  //     } else if (deviceType.toLowerCase() === "franklin") {
  //       Navigate(`/FranklinDetails`);
  //     } else {
  //       console.error(
  //         `Device details not found for device type: ${deviceType}`
  //       );
  //     }
  //   } else {
  //     console.error(`Device details not found for device type: ${deviceType}`);
  //   }
  // };
  const handleDetailsClick = (deviceType) => {
    // console.log("Clicked on device type:", deviceType);

    // Normalize the device type for comparison
    const normalizedDeviceType = deviceType.toLowerCase().replace(/\s+/g, "");

    // Find the selected device data
    // const selectedDeviceData = data.find((device) => {
    //   return (
    //     device.device_type.toLowerCase().replace(/\s+/g, "") ===
    //     normalizedDeviceType
    //   );
    // });
    const selectedDeviceData = displayData.find((device) => {
      if (!device.device_type || typeof device.device_type !== "string")
        return false;

      return (
        device.device_type.toLowerCase().replace(/\s+/g, "") ===
        normalizedDeviceType
      );
    });

    // If device data is found, set it in the state
    if (selectedDeviceData) {
      // console.log("Selected Device Data:", selectedDeviceData);
      setSelectedDevice(selectedDeviceData);
    } else {
      console.error(`Device details not found for device type: ${deviceType}`);
    }

    // Navigate based on the normalized device type
    switch (normalizedDeviceType) {
      case "inverter":
        Navigate(`/InverterDetails`);
        break;
      case "thermostat":
        Navigate(`/ThermostatDetails`);
        break;
      case "battery":
        Navigate(`/BatteryDetails`);
        break;
      case "vehicle":
        Navigate(`/VehicleDetails`);
        break;
      case "franklinwh":
        Navigate(`/FranklinDetails`);
        break;
      case "solark":
        Navigate(`/SolArkDetails`);
        break;
      case "hoymiles":
        Navigate(`/HoymilesDetails`);
        break;
      case "franklin":
        Navigate(`/FranklinUnifiedDetails`);
        break;
      default:
        console.error(`No navigation found for device type: ${deviceType}`);
        break;
    }
  };

  if (deviceCounts["Thermostat"]) {
    capacity += deviceCounts["Thermostat"] * 0.25;
  }
  if (deviceCounts["Battery"]) {
    capacity += deviceCounts["Battery"] * 3;
  }
  if (deviceCounts["Vehicle"]) {
    capacity += deviceCounts["Vehicle"] * 3;
  }

  if (dispatchingDeviceCounts["Thermostat"]) {
    currentlyDispatching += dispatchingDeviceCounts["Thermostat"] * 0.25;
  }
  if (dispatchingDeviceCounts["Battery"]) {
    currentlyDispatching += dispatchingDeviceCounts["Battery"] * 3;
  }
  if (dispatchingDeviceCounts["Vehicle"]) {
    currentlyDispatching += dispatchingDeviceCounts["Vehicle"] * 3;
  }
  generatingCapacity = deviceCounts["Inverter"];

  console.log(generatingCapacity);
  const handleFilterChange = async (selectedDeviceType) => {
    if (selectedDeviceType === "All") {
      console.log("Selected Device Type:", selectedDeviceType);

      // fetchAllData handled in context, so just reset displayData
      setDisplayData(contextData);
      setLocations(
        contextData.map((device) => ({ lat: device.latitude, lng: device.longitude }))
      );
    }
    if (selectedDeviceType === "Thermostat") {
      try {
        const connectThermolist = process.env.REACT_APP_THERMOSTAT_URL;
        const storedAccessToken = localStorage.getItem("accessToken");
        if (!storedAccessToken) {
          throw new Error("Access token not found");
        }
        const response = await fetch(connectThermolist, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${storedAccessToken}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        console.log("Thermostat data:", data);

        setThermostatData(data);
      } catch (error) {
        console.error("Error fetching Thermostat data:", error);
      }
    }
    if (selectedDeviceType === "Inverter") {
      try {
        const connectInverterlist = process.env.REACT_APP_INVERTER_URL;
        const storedAccessToken = localStorage.getItem("accessToken");
        if (!storedAccessToken) {
          throw new Error("Access token not found");
        }
        const response = await fetch(connectInverterlist, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${storedAccessToken}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        console.log("Inverterlist:", data);
        setinverterData(data);
      } catch (error) {
        console.error("Error fetching inveter data:", error);
      }
    }
    if (selectedDeviceType === "Vehicle") {
      try {
        const connectVehiclelist = process.env.REACT_APP_VEHICLE_URL;
        const storedAccessToken = localStorage.getItem("accessToken");
        if (!storedAccessToken) {
          throw new Error("Access token not found");
        }
        const response = await fetch(connectVehiclelist, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${storedAccessToken}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        console.log("Inverterlist:", data);
        setVehicleData(data);
      } catch (error) {
        console.error("Error fetching Vehcile data:", error);
      }
    }
    if (selectedDeviceType === "Battery") {
      try {
        const connectVehiclelist = process.env.REACT_APP_VEHICLE_URL;
        const storedAccessToken = localStorage.getItem("accessToken");
        if (!storedAccessToken) {
          throw new Error("Access token not found");
        }
        const response = await fetch(connectVehiclelist, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${storedAccessToken}`,
          },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        console.log("Inverterlist:", data);
        setVehicleData(data);
      } catch (error) {
        console.error("Error fetching Vehcile data:", error);
      }
    } else {
      const filteredData = contextData.filter(
        (device) =>
          device.device_type.toLowerCase().replace(/\s+/g, "") ===
          selectedDeviceType.toLowerCase()
      );
      console.log("Filtered Data:", filteredData);
      setDisplayData(filteredData);
    }
  };

  return (
    <div className={styles.fleet_view_cantaint}>
      {loading && loading && <Loader />}
      <section className={styles.topbar}>
        <div className={styles.container}>
          <img
            className={styles.topbar_logo}
            src={logoSvg}
            alt="Topbar Logo"
          />
        </div>
        <div className={styles.topbar_right}>
          <button
            style={{
              backgroundColor: '#fff',
              color: '#FF5900',
              border: 'none',
              borderRadius: '50px',
              padding: '8px 24px',
              fontSize: '16px',
              fontWeight: '600',
              fontFamily: "'Forma DJR Deck', sans-serif",
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textDecoration: 'none',
            }}
            onClick={() => window.open('/PPAProjects', '_blank')}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#ffe0cc')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
          >
            Daylight Fleet dashboard
          </button>
          <button
            style={{
              backgroundColor: '#fff',
              color: '#FF5900',
              border: 'none',
              borderRadius: '50px',
              padding: '8px 24px',
              fontSize: '16px',
              fontWeight: '600',
              fontFamily: "'Forma DJR Deck', sans-serif",
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              textDecoration: 'none',
            }}
            onClick={() => window.open('/WeatherDashboard', '_blank')}
            onMouseEnter={(e) => (e.target.style.backgroundColor = '#ffe0cc')}
            onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
          >
            Solar Dashboard
          </button>
          <div
            onClick={() => {
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              Navigate("/");
            }}
          >
            Logout
          </div>
        </div>
      </section>

      <section className={styles.fleet_view}>
        <div className={styles.container}>
          <div className="row">
            <div className="col-md-12">
              <div className={styles.view_header}>
                <h2 className={styles.main_title}>Fleet View</h2>
                <div className={styles.view_header_right}>
                  <div style={{ width: "280px", zIndex: 100 }}>
                    <Select
                      options={[
                        { value: "All", label: "All Utility" },
                        ...(contextUtilities || []).map((utility) => ({
                          value: utility.id.toString(),
                          label: utility.utility_name,
                        })),
                      ]}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: "#fff",
                          borderColor: "#b6b6b6",
                          minHeight: "35px",
                          height: "35px",
                          boxShadow: "none",
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#4c2806",
                          borderRadius: "3px",
                          cursor: "pointer"
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "35px",
                          padding: "0 6px",
                          display: "flex",
                          alignItems: "center"
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "#4c2806",
                          position: "relative",
                          top: "auto",
                          transform: "none",
                          margin: 0,
                          maxWidth: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0px",
                          padding: "0px"
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "35px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                          fontSize: "13px",
                          color: "#4c2806"
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected ? "#ffe0b2" : state.isFocused ? "#fff7e9" : "white",
                          color: "#4c2806",
                          cursor: "pointer"
                        })
                      }}
                      value={
                        selectedUtility === "All"
                          ? { value: "All", label: "All Utility" }
                          : (contextUtilities || []).map(u => ({ value: u.id.toString(), label: u.utility_name })).find(opt => opt.value === selectedUtility)
                      }
                      onChange={(option) => setSelectedUtility(option ? option.value : "All")}
                      placeholder="Select Utility"
                      isSearchable
                      isClearable
                    />
                  </div>
                  <div style={{ width: "200px", zIndex: 100 }}>
                    <Select
                      options={[
                        { value: "All", label: "All States" },
                        ...US_STATES.map((state) => ({ value: state, label: state })),
                      ]}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          backgroundColor: "#fff",
                          borderColor: "#b6b6b6",
                          minHeight: "35px",
                          height: "35px",
                          boxShadow: "none",
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#4c2806",
                          borderRadius: "3px",
                          cursor: "pointer"
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "35px",
                          padding: "0 6px",
                          display: "flex",
                          alignItems: "center"
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: "#4c2806",
                          position: "relative",
                          top: "auto",
                          transform: "none",
                          margin: 0,
                          maxWidth: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }),
                        input: (provided) => ({
                          ...provided,
                          margin: "0px",
                          padding: "0px"
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "35px",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                          fontSize: "13px",
                          color: "#4c2806"
                        }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isSelected ? "#ffe0b2" : state.isFocused ? "#fff7e9" : "white",
                          color: "#4c2806",
                          cursor: "pointer"
                        })
                      }}
                      value={
                        selectedState === "All"
                          ? { value: "All", label: "All States" }
                          : { value: selectedState, label: selectedState }
                      }
                      onChange={(option) => setSelectedState(option ? option.value : "All")}
                      placeholder="Select State"
                      isSearchable
                      isClearable
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className={styles.fleet_view_left}>
                <div className={styles.location_filter}>
                  <Map
                    data={displayData}
                    franklinData={contextFranklinData}
                    unifiedDevices={contextUnifiedDevices}
                    selectedState={selectedState}
                    selectedUtility={selectedUtility}
                    utilities={contextUtilities}
                  />
                </div>
                <div className={styles.device_counts}>
                  <div className={styles.tableUpper}>
                    {" "}
                    <h4>Device</h4> <h4 className={styles.countss}>Counts</h4>
                    <h4>Details</h4>
                  </div>
                  <div className="table-responsive">
                    {/* <table className={styles.table} style={{ width: "100%" }}>
                      <tbody>
                        {deviceCounts &&
                          Object.entries(deviceCounts).map(
                            ([deviceType, count], index) => (
                              <tr key={index} className={styles.tableTR}>
                                <td className={styles.devicetype}>
                                  {deviceType === "Inverter"
                                    ? "Solar"
                                    : deviceType === "Vehicle"
                                    ? "Electric Vehicle"
                                    : deviceType}
                                </td>

                                <td className={styles.Counttd}>{count}</td>
                                <td
                                  className={styles.details}
                                  onClick={() => handleDetailsClick(deviceType)}
                                >
                                  Details
                                </td>
                              </tr>
                            )
                          )}

                        <tr className={styles.tableborder}></tr>
                        <tr className={styles.tableTR}>
                          <td style={{ width: "55%" }}>
                            <b>Total</b>
                          </td>
                          <td
                            style={{ width: "50%" }}
                            className={styles.countin}
                          >
                            <b>
                              {Object.values(deviceCounts).reduce(
                                (total, count) => total + count,
                                0
                              )}
                            </b>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table> */}
                    <table className={styles.table} style={{ width: "100%" }}>
                      <tbody>
                        {combinedDeviceCounts &&
                          Object.entries(combinedDeviceCounts).map(
                            ([deviceType, count], index) => (
                              <tr key={index} className={styles.tableTR}>
                                <td className={styles.devicetype}>
                                  {deviceType === "Inverter"
                                    ? "Solar"
                                    : deviceType === "Vehicle"
                                      ? "Electric Vehicle"
                                      : deviceType === "SolArk"
                                        ? "Sol-Ark"
                                        : deviceType === "Hoymiles"
                                          ? "Hoymiles"
                                          : deviceType === "Franklin"
                                            ? "Franklin"
                                            : deviceType}
                                </td>

                                <td className={styles.Counttd}>{count}</td>
                                <td
                                  className={styles.details}
                                  onClick={() => handleDetailsClick(deviceType)}
                                >
                                  Details
                                </td>
                              </tr>
                            )
                          )}

                        <tr className={styles.tableborder}></tr>
                        <tr className={styles.tableTR}>
                          <td style={{ width: "55%" }}>
                            <b>Total</b>
                          </td>
                          <td
                            style={{ width: "50%" }}
                            className={styles.countin}
                          >
                            <b>
                              {Object.values(combinedDeviceCounts).reduce(
                                (total, count) => total + count,
                                0
                              )}
                            </b>
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className={styles.fleet_view_left}>
                <div className={styles.dispatch_available_capacity}>
                  <h3>
                    Dispatch fleet available capacity:
                    <span className={styles.dispatch}>
                      <Link
                        className={styles.dispatchLink}
                        to="/DispatchResource"
                      >
                        Dispatch
                      </Link>
                    </span>
                  </h3>
                  <div className={`row ${styles.customRow}`}>
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-6">
                      <div className={styles.card_box}>
                        <p>
                          <b>Flexible Capacity</b>
                          <br />
                          <span className={styles.kwh}> {capacity} kWh</span>
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-6">
                      <div className={styles.card_box}>
                        <p>
                          <b>Generating Capacity</b>
                          <br />
                          <span className={styles.kwh}>
                            {generatingCapacity} kWh
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-6">
                      <div className={styles.card_box}>
                        <p>
                          <b>Currently Dispatching</b>
                          <br />
                          <span className={styles.kwh}>
                            {currentlyDispatching} kWh
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.dispatchable_forecarst}>
                  <h4>Dispatchable Capacity Forecast</h4>
                  {/* <img className={styles.capicityforcast} src={capicityForcast} alt="Capacity Forecast" /> */}
                  <Chartapp />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default Homepage;
